
<div
  :class="jel_getClassObject(content, { [content.type]: true })"
  class="contenu_html_taille_defaut"
  v-html="content.codeHTML"
></div>
